import {Link, useLocation} from "react-router-dom";
import Logo from "../assets/images/iCXeed-logo.png";
import IntroductionIcon from "../assets/images/navicons/introduction.svg";
import OurDNAIcon from "../assets/images/navicons/our-dna.svg";
import RecruitmentProcessIcon from "../assets/images/navicons/recruitment-process.svg";
import NewExpertOrientationIcon from "../assets/images/navicons/new-expert-orientation.svg";
import TrainingIcon from "../assets/images/navicons/training.svg";
import PhilippineHolidaIcon from "../assets/images/navicons/philippine-holiday.svg";
import InformationSecurityIcon from "../assets/images/navicons/information-security.svg";
import OurTeamIcon from "../assets/images/navicons/our-team.svg";
import MobileMenu from "./MobileMenu";

const LeftSectionBlock = () => {
  const location = useLocation();
  const isIntroductionPage = location.pathname === "/introduction";
  const isOurDNAPage = location.pathname === "/our-dna";
  const isRecruitmentPage = location.pathname === "/recruitment-process";
  const isExpertOrientationPage =
    location.pathname === "/new-expert-orientation";
  const isTrainingPage = location.pathname === "/training";
  const isPHHolidayPage = location.pathname === "/philippine-holidays";
  const isInformationSecurityPage =
    location.pathname === "/information-security";
  const isOurTeamPage = location.pathname === "/our-team";

  return (
    <>
      <div className="left-section-blk">
        <Link to="/introduction">
          <img alt="iCXeed Logo" src={Logo} className="logo-left-section" />
        </Link>
        <ul>
          <li>
            <Link
              to="/introduction"
              className={isIntroductionPage ? "active" : ""}>
              <img alt="Introduction" src={IntroductionIcon} />
              Introduction
            </Link>
          </li>
          <li>
            <Link to="/our-team" className={isOurTeamPage ? " active" : ""}>
              <img alt="Our Team" src={OurTeamIcon} />
              Who's Who at iCXeed
            </Link>
          </li>
          <li>
            <Link to="/our-dna" className={isOurDNAPage ? "active" : ""}>
              <img alt="Our DNA" src={OurDNAIcon} />
              Our DNA
            </Link>
          </li>
          <li>
            <Link
              to="/recruitment-process"
              className={isRecruitmentPage ? "active" : ""}>
              <img alt="Recruitment Process" src={RecruitmentProcessIcon} />
              Recruitment Process
            </Link>
          </li>
          <li>
            <Link
              to="/new-expert-orientation"
              className={isExpertOrientationPage ? "active" : ""}>
              <img
                alt="New Expert Orientation"
                src={NewExpertOrientationIcon}
              />
              New Expert Orientation
            </Link>
          </li>
          <li>
            <Link to="/training" className={isTrainingPage ? "active" : ""}>
              <img alt="Training" src={TrainingIcon} />
              Training
            </Link>
          </li>

          <li>
            <Link
              to="/information-security"
              className={isInformationSecurityPage ? " active" : ""}>
              <img alt="Information Security" src={InformationSecurityIcon} />
              Information Security
            </Link>
          </li>

          <li>
            <Link
              to="/philippine-holidays"
              className={isPHHolidayPage ? " active" : ""}>
              <img alt="Philippine Holiday" src={PhilippineHolidaIcon} />
              Philippine Holidays
            </Link>
          </li>
        </ul>
      </div>

      <div className="left-section-blk-mobile">
        <Link to="/introduction">
          <img alt="iCXeed Logo" src={Logo} className="logo-left-section" />
        </Link>
        <MobileMenu />
      </div>
    </>
  );
};

export default LeftSectionBlock;
